import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _Object$keys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import backTrack, { VIP_CLOSE_TOAST } from "@/utils/backTrack";
import { sendMapEvent } from "@/utils/analytics";
import { i18n } from "@/i18n/i18n-setup";
import GeneralUtilsHelper from "@/utils/generalUtils";
import headerVideo from "./headerVideo/headerVideo.vue";
import VipBotton from "./vipBotton/vipBotton.vue";
import EventBus from "@/utils/eventBus";

var VipPlanC =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipPlanC, _Vue);

  function VipPlanC() {
    var _this;

    _classCallCheck(this, VipPlanC);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VipPlanC).apply(this, arguments));
    _this.isSelected = true;
    _this.isShowCloseIcon = false;
    _this.key = "";
    _this.offerId = null;
    _this.vipTime = "month";
    _this.textList = [i18n.t("vip_plan.vip_plan_c.text_array[0]"), i18n.t("vip_plan.vip_plan_c.text_array[1]"), i18n.t("vip_plan.vip_plan_c.text_array[2]"), i18n.t("vip_plan.vip_plan_c.text_array[3]")];
    return _this;
  }

  _createClass(VipPlanC, [{
    key: "clickClose",
    value: function clickClose() {
      var _this2 = this;

      if (!this.isShowCloseIcon) {
        return;
      }

      backTrack.listen({
        key: VIP_CLOSE_TOAST,
        fn: function fn() {
          _this2.hideVipToast();
        }
      });
      this.showCloseToast();
    }
  }, {
    key: "showCloseToast",
    value: function showCloseToast() {
      sendMapEvent('uia_vip_before_unload_dialog', {
        key: 'show'
      });
      this.showVipToast({
        confirmFn: this.buyToastVip,
        cancelFn: this.goBack
      });
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(name) {
      sendMapEvent(this.key, {
        key: name
      });
    }
  }, {
    key: "initData",
    value: function initData() {
      var _this3 = this;

      this.key = this.$route.query.key;
      this.vipTime = this.$route.query.vipTime;
      this.isSelected = this.$route.query.freeTrailEnable;
      this.changeOfferId();
      var closeIconShowTime = this.settingData && this.settingData.client && this.settingData.client.vip_config ? this.settingData.client.vip_config.vip_close_btn_delay_show_time : 2000;
      setTimeout(function () {
        _this3.isShowCloseIcon = true;
      }, closeIconShowTime);
    }
  }, {
    key: "hideVipToast",
    value: function hideVipToast() {
      backTrack.destroy(VIP_CLOSE_TOAST);
      EventBus.$emit("vip-toast-show", {
        show: false
      });
    }
  }, {
    key: "goBack",
    value: function goBack() {
      this.hideVipToast();
      backTrack.destroy(this.$route.name);
      this.routerGoBack(-1);
    }
  }, {
    key: "selectFreeTrial",
    value: function selectFreeTrial() {
      this.isSelected = !this.isSelected;
      GeneralUtilsHelper.vibratePhone(-1, [11, 22, -1]);
      this.changeOfferId();
    }
  }, {
    key: "changeOfferId",
    value: function changeOfferId() {
      var _this4 = this;

      if (this.isSelected) {
        this.offerId = null;
      } else {
        this.offerId = _Object$keys(this.offerMap).find(function (item) {
          return _this4.offerMap[item].subscription.period_type.includes(_this4.vipTime) && _this4.offerMap[item].free_slogan.toUpperCase() === "CONTINUE";
        });
      }
    }
  }, {
    key: "buyVIP",
    value: function () {
      var _buyVIP = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.sendEvent("click");
                _context.next = 4;
                return this.payVip(this.offerId);

              case 4:
                result = _context.sent;

                if (result) {
                  sendMapEvent("uia_vip_buyway", {
                    key: this.key
                  });
                  this.updateResultByName({
                    name: "canShowSuccessToast",
                    result: true
                  });
                  this.goBack();
                  this.sendEvent("buy");
                } else {
                  _Toast(i18n.t("toast.purchase_failed"));
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function buyVIP() {
        return _buyVIP.apply(this, arguments);
      }

      return buyVIP;
    }()
  }, {
    key: "buyToastVip",
    value: function () {
      var _buyToastVip = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                sendMapEvent('uia_vip_before_unload_dialog', {
                  key: 'click'
                });
                _context2.next = 4;
                return this.payVip();

              case 4:
                result = _context2.sent;

                if (result) {
                  sendMapEvent('uia_vip_before_unload_dialog', {
                    key: 'buy'
                  });
                  sendMapEvent("uia_vip_buyway", {
                    key: 'before_unload_dialog'
                  });
                  this.updateResultByName({
                    name: "canShowSuccessToast",
                    result: true
                  });
                  this.goBack();
                } else {
                  _Toast(i18n.t("toast.purchase_failed"));
                }

                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function buyToastVip() {
        return _buyToastVip.apply(this, arguments);
      }

      return buyToastVip;
    }()
  }, {
    key: "created",
    value: function created() {
      this.initData();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this5 = this;

      this.sendEvent("show");
      backTrack.listen({
        key: this.$route.name,
        fn: function fn() {
          _this5.clickClose();
        }
      });
      this.$nextTick(function () {
        console.log("vip mounted:", new Date().valueOf());
      });
    }
  }]);

  return VipPlanC;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], VipPlanC.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.PAY_BY_IAP)], VipPlanC.prototype, "payByIap", void 0);

tslib_1.__decorate([Action(types.SHOW_VIP_TOAST)], VipPlanC.prototype, "showVipToast", void 0);

tslib_1.__decorate([Mutation(types.HIDE_TOAST)], VipPlanC.prototype, "hideToast", void 0);

tslib_1.__decorate([Getter(types.GETTER_SETTING_DATA)], VipPlanC.prototype, "settingData", void 0);

tslib_1.__decorate([Action(types.PAY_VIP)], VipPlanC.prototype, "payVip", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_SERVICE_LIST)], VipPlanC.prototype, "updateServiceList", void 0);

tslib_1.__decorate([Getter(types.GETTER_LAUNCH_CONFIG)], VipPlanC.prototype, "lunchConfig", void 0);

tslib_1.__decorate([Getter(types.GETTER_OFFER_MAP)], VipPlanC.prototype, "offerMap", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_RESULT_BY_NAME)], VipPlanC.prototype, "updateResultByName", void 0);

VipPlanC = tslib_1.__decorate([Component({
  components: {
    headerVideo: headerVideo,
    VipBotton: VipBotton
  }
})], VipPlanC);
export default VipPlanC;